export const INTERCOM_APP_ID = 'r6ozvojt';
export const INTERCOM_API_BASE = 'https://api-iam.intercom.io';
export const INTERCOM_LAUNCHER_INSET_PX = 20;
export const INTERCOM_LAUNCHER_SIZE_PX = 48;
